export const tournamentDataByCategory = {
  "m-distance145": {
    round16: [
      { player1: "김경하", player2: "안종현", winner: 1 },
      { player1: "박진환", player2: "김진희", winner: 2 },
      { player1: "최대식", player2: "정연광", winner: 2 },
      { player1: "장상수", player2: "장규혁", winner: 2 },
      { player1: "이재호", player2: "김성환", winner: 2 },
      { player1: "송봉현", player2: "조병균", winner: 1 },
      { player1: "강영도", player2: "MAGOMEDARIF MIRZAEV", winner: 2 },
      { player1: "권혁기", player2: "정한욱", winner: 2 },
    ],
    round8: [
      { player1: "김경하", player2: "김진희", winner: 1 },
      { player1: "정연광", player2: "장규혁", winner: 1 },
      { player1: "김성환", player2: "송봉현", winner: 1 },
      { player1: "MAGOMEDARIF MIRZAEV", player2: "정한욱", winner: 1 },
    ],
    round4: [
      { player1: "김경하", player2: "정연광", winner: 2 },
      { player1: "김성환", player2: "MAGOMEDARIF MIRZAEV", winner: 2 },
    ],
    round3: [{ player1: "김경하", player2: "김성환", winner: 2 }],
    round2: [{ player1: "정연광", player2: "MAGOMEDARIF MIRZAEV", winner: 2 }],
  },
  "m-distance90": {
    round16: [
      {
        player1: "ZHANIBEK SALAMATULY",
        player2: "Paul Douglas Handley",
        winner: 2,
      },
      {
        player1: "MOHD ZAHRUL SHAFIQ BIN ZAHAR",
        player2: "SÁNDOR TÁMBA",
        winner: 1,
      },
      { player1: "GANZORIG BAT-ERDENE", player2: "PURNAMA PURNAMA", winner: 1 },
      {
        player1: "MOHD SHAH IDZUWAN BIN AHMAD SABRI",
        player2: "MURAT Üstün",
        winner: 1,
      },
      { player1: "김도성", player2: "HAYATİ AKKAYA", winner: 1 },
      { player1: "Akrom Tolaemah", player2: "Donko Kolev", winner: 1 },
      { player1: "Abdul Baset Hamidi", player2: "ISTVÁN LADOVER", winner: 1 },
      { player1: "강보순", player2: "ZORIGTBAATAR BOR", winner: 2 },
    ],
    round8: [
      {
        player1: "Paul Douglas Handley",
        player2: "MOHD ZAHRUL SHAFIQ BIN ZAHAR",
        winner: 1,
      },
      {
        player1: "GANZORIG BAT-ERDENE",
        player2: "MOHD SHAH IDZUWAN BIN AHMAD SABRI",
        winner: 2,
      },
      { player1: "김도성", player2: "Akrom Tolaemah", winner: 2 },
      { player1: "Abdul Baset Hamidi", player2: "ZORIGTBAATAR BOR", winner: 2 },
    ],
    round4: [
      { player1: "Paul Douglas Handley", player2: "MOHD SHAH IDZUWAN BIN AHMAD SABRI", winner: 2 },
      { player1: "Akrom Tolaemah", player2: "ZORIGTBAATAR BOR", winner: 1 },
    ],
    round3: [
      {
        player1: "Paul Douglas Handley",
        player2: "ZORIGTBAATAR BOR",
        winner: 1,
      },
    ],
    round2: [
      {
        player1: "MOHD SHAH IDZUWAN BIN AHMAD SABRI",
        player2: "Akrom Tolaemah",
        winner: 2,
      },
    ],
  },
  "m-distance70": {
    round16: [
      { player1: "GANZORIG BAT-ERDENE", player2: "ILYAS BIN PADE", winner: 1 },
      {
        player1: "YNTYMAK MURADIL UULU",
        player2: "NARANBAYAR BATKHUYAG",
        winner: 1,
      },
      { player1: "SHENBERG MUNKUEV", player2: "JÓZSEF SZALMA", winner: 1 },
      { player1: "MURAT LUKPANOV", player2: "GAFUR RAKHMANGULOV", winner: 1 },
      { player1: "iBRAHİM AFRAZİLOĞLU", player2: "MARAT BEXULTAN", winner: 2 },
      {
        player1: "OLZHAS DYUSSUPOV",
        player2: "ZHANIBEK KULMIRZAYEV",
        winner: 2,
      },
      { player1: "MAKSAT ABDIKERIMOV", player2: "HAYATİ AKKAYA", winner: 1 },
      {
        player1: "MOHD RIZMI BIN HANAFIAH",
        player2: "MOHD ZAHRUL SHAFIQ BIN ZAHAR",
        winner: 1,
      },
    ],
    round8: [
      {
        player1: "GANZORIG BAT-ERDENE",
        player2: "YNTYMAK MURADIL UULU",
        winner: 1,
      },
      { player1: "SHENBERG MUNKUEV", player2: "MURAT LUKPANOV", winner: 1 },
      {
        player1: "MARAT BEXULTAN",
        player2: "ZHANIBEK KULMIRZAYEV",
        winner: 2,
      },
      {
        player1: "MAKSAT ABDIKERIMOV",
        player2: "MOHD RIZMI BIN HANAFIAH",
        winner: 1,
      },
    ],
    round4: [
      { player1: "GANZORIG BAT-ERDENE", player2: "SHENBERG MUNKUEV", winner: 1 },
      { player1: "ZHANIBEK KULMIRZAYEV", player2: "MAKSAT ABDIKERIMOV", winner: 2 },
    ],
    round3: [
      {
        player1: "ZHANIBEK KULMIRZAYEV",
        player2: "SHENBERG MUNKUEV",
        winner: 1,
      },
    ],
    round2: [
      {
        player1: "MAKSAT ABDIKERIMOV",
        player2: "GANZORIG BAT-ERDENE",
        winner: 2,
      },
    ],
  },
  "m-distance30": {
    round16: [
      { player1: "ILYAS BIN PADE", player2: "Abdul Baset Hamidi", winner: 1 },
      {
        player1: "MOHAMAD FADHIL BIN ABDULLAH",
        player2: "PURNAMA PURNAMA",
        winner: 2,
      },
      {
        player1: "GANZORIG BAT-ERDENE",
        player2: "MOHD RIZMI BIN HANAFIAH",
        winner: 1,
      },
      { player1: "OLEG TSYBIKZHAPOV", player2: "민병준", winner: 1 },
      { player1: "JÓZSEF SZALMA", player2: "MAKSAT ABDIKERIMOV", winner: 2 },
      { player1: "SHAHRAM HADAVAND", player2: "OLZHAS DYUSSUPOV", winner: 2 },
      {
        player1: "ASKARBEK USSABAYEV",
        player2: "SUPARDI BIN JAMAL",
        winner: 1,
      },
      {
        player1: "YNTYMAK MURADIL UULU",
        player2: "BATTUMUR JANCHIV",
        winner: 2,
      },
    ],
    round8: [
      { player1: "ILYAS BIN PADE", player2: "PURNAMA PURNAMA", winner: 1 },
      {
        player1: "GANZORIG BAT-ERDENE",
        player2: "OLEG TSYBIKZHAPOV",
        winner: 1,
      },
      { player1: "MAKSAT ABDIKERIMOV", player2: "OLZHAS DYUSSUPOV", winner: 1 },
      { player1: "ASKARBEK USSABAYEV", player2: "BATTUMUR JANCHIV", winner: 1 },
    ],
    round4: [
      { player1: "ILYAS BIN PADE", player2: "GANZORIG BAT-ERDENE", winner: 2 },
      { player1: "MAKSAT ABDIKERIMOV", player2: "ASKARBEK USSABAYEV", winner: 1 },
    ],
    round3: [
      {
        player1: "ILYAS BIN PADE",
        player2: "ASKARBEK USSABAYEV",
        winner: 1,
      },
    ],
    round2: [
      { player1: "GANZORIG BAT-ERDENE", player2: "MAKSAT ABDIKERIMOV", winner: 1 },
    ],
  },
  "f-distance145": {
    round16: [
      { player1: "신옥선", player2: "김우성", winner: 1 },
      { player1: "임연숙", player2: "황현희", winner: 2 },
      { player1: "배봉숙", player2: "TUVAANJAV TSOGBADRAKH", winner: 1 },
      { player1: "박정미", player2: "김현지", winner: 1 },
      { player1: "최성민", player2: "김정애", winner: 2 },
      { player1: "조정희", player2: "하부자", winner: 2 },
      { player1: "여해인", player2: "권오순", winner: 1 },
      { player1: "김경화", player2: "손미희", winner: 2 },
    ],
    round8: [
      { player1: "신옥선", player2: "황현희", winner: 1 },
      { player1: "배봉숙", player2: "박정미", winner: 1 },
      { player1: "김정애", player2: "하부자", winner: 1 },
      { player1: "여해인", player2: "손미희", winner: 1 },
    ],
    round4: [
      { player1: "신옥선", player2: "배봉숙", winner: 2 },
      { player1: "김정애", player2: "여해인", winner: 1 },
    ],
    round3: [{ player1: "신옥선", player2: "여해인", winner: 1 }],
    round2: [{ player1: "배봉숙", player2: "김정애", winner: 1 }],
  },
  "f-distance90": {
    round16: [
      { player1: "SENA KEÇECİ", player2: "ANDREA DR. SKALICZKY", winner: 2 },
      { player1: "SEVGİ DURAN", player2: "손미희", winner: 1 },
      { player1: "하부자", player2: "신옥선", winner: 1 },
      { player1: "권오순", player2: "OTGONJARGAL BADARCH", winner: 2 },
      { player1: "임연숙", player2: "KUNDYZ NURALINA", winner: 1 },
      { player1: "TITIN TITIN", player2: "ASEL SADYROVA", winner: 1 },
      { player1: "AYSUN DEMİRCİ", player2: "양경희", winner: 1 },
      {
        player1: "CHOLPONAI UMURKULOVA",
        player2: "Nusaibah Schellen",
        winner: 2,
      },
    ],
    round8: [
      { player1: "ANDREA DR. SKALICZKY", player2: "SEVGİ DURAN", winner: 1 },
      { player1: "하부자", player2: "OTGONJARGAL BADARCH", winner: 2 },
      { player1: "임연숙", player2: "TITIN TITIN", winner: 1 },
      { player1: "AYSUN DEMİRCİ", player2: "Nusaibah Schellen", winner: 2 },
    ],
    round4: [
      { player1: "ANDREA DR. SKALICZKY", player2: "OTGONJARGAL BADARCH", winner: 1 },
      { player1: "임연숙", player2: "Nusaibah Schellen", winner: 2 },
    ],
    round3: [{ player1: "OTGONJARGAL BADARCH", player2: "임연숙", winner: 1 }],
    round2: [
      {
        player1: "Nusaibah Schellen",
        player2: "ANDREA DR. SKALICZKY",
        winner: 2,
      },
    ],
  },
  "f-distance70": {
    round16: [
      { player1: "ASEL SADYROVA", player2: "MADINA BISSEMBIYEVA", winner: 1 },
      { player1: "SEVGİ DURAN", player2: "NORSIANI BINTI MOHD NOR", winner: 1 },
      { player1: "ANDREA DR. SKALICZKY", player2: "양경희", winner: 1 },
      {
        player1: "ASSEMGUL GALYMZHANOVA",
        player2: "KHANDKHUU TSANKHIA",
        winner: 2,
      },
      { player1: "Nusaibah Schellen", player2: "TITIN TITIN", winner: 1 },
      { player1: "AIKORKEM BATIKHAN", player2: "AYSUN DEMİRCİ", winner: 1 },
      { player1: "FARIZA SABYRZHAN", player2: "양경희", winner: 1 },
      { player1: "OTGONJARGAL BADARCH", player2: "SENA KEÇECİ", winner: 2 },
    ],
    round8: [
      { player1: "ASEL SADYROVA", player2: "SEVGİ DURAN", winner: 2 },
      {
        player1: "ANDREA DR. SKALICZKY",
        player2: "KHANDKHUU TSANKHIA",
        winner: 2,
      },
      { player1: "Nusaibah Schellen", player2: "AIKORKEM BATIKHAN", winner: 1 },
      { player1: "FARIZA SABYRZHAN", player2: "SENA KEÇECİ", winner: 2 },
    ],
    round4: [
      { player1: "SEVGİ DURAN", player2: "KHANDKHUU TSANKHIA", winner: 1 },
      { player1: "Nusaibah Schellen", player2: "SENA KEÇECİ", winner: 1 },
    ],
    round3: [
      { player1: "KHANDKHUU TSANKHIA", player2: "SENA KEÇECİ", winner: 2 },
    ],
    round2: [
      { player1: "Nusaibah Schellen", player2: "SEVGİ DURAN", winner: 2 },
    ],
  },
  "f-distance30": {
    round16: [
      {
        player1: "AYASH KABDOLLAYEVA",
        player2: "BEGIMAY SALMORBEK KYZY",
        winner: 1,
      },
      {
        player1: "KHALIZA BINTI OTHMAN",
        player2: "OTGONJARGAL BADARCH",
        winner: 1,
      },
      {
        player1: "Nusaibah Schellen",
        player2: "MÁRTA SZALMÁNÉ BÚS",
        winner: 1,
      },
      {
        player1: "AIKORKEM BATIKHAN",
        player2: "BULGAN TSAGAANZAAN",
        winner: 1,
      },
      { player1: "AYSUN DEMİRCİ", player2: "LYAZZAT AKHMETOVA", winner: 2 },
      {
        player1: "BİRSEN BİLGİNOĞLU",
        player2: "AYŞEGÜL DEMİRBAĞ ÇALIŞKAN",
        winner: 1,
      },
      { player1: "ASEL SADYROVA", player2: "KHANDKHUU TSANKHIA", winner: 1 },
      {
        player1: "HALİDE FİKRET ÇAKMAK",
        player2: "FARIZA SABYRZHAN",
        winner: 2,
      },
    ],
    round8: [
      {
        player1: "AYASH KABDOLLAYEVA",
        player2: "KHALIZA BINTI OTHMAN",
        winner: 1,
      },
      { player1: "Nusaibah Schellen", player2: "AIKORKEM BATIKHAN", winner: 2 },
      { player1: "LYAZZAT AKHMETOVA", player2: "BİRSEN BİLGİNOĞLU", winner: 2 },
      { player1: "ASEL SADYROVA", player2: "FARIZA SABYRZHAN", winner: 2 },
    ],
    round4: [
      { player1: "AYASH KABDOLLAYEVA", player2: "AIKORKEM BATIKHAN", winner: 1 },
      { player1: "BİRSEN BİLGİNOĞLU", player2: "FARIZA SABYRZHAN", winner: 2 },
    ],
    round3: [
      { player1: "AIKORKEM BATIKHAN", player2: "BİRSEN BİLGİNOĞLU", winner: 1 },
    ],
    round2: [
      { player1: "FARIZA SABYRZHAN", player2: "AYASH KABDOLLAYEVA", winner: 2 },
    ],
  },
};
